import { Obstruction } from '../obstruction.class';
// import { IslandSkuAssetData } from '../data/obstruction-sku-asset-data.class';

/**
 * Calculates island baseSize bsaed on island type. Base size represents the outside dimensions and do not include countertop overhangs
 * @param island Island to calculate the base size for
 * @param skuData [string, IslandAssetData]
 * @returns Size
 */
export const getBaseMsrpCfn = (island: Obstruction, sku: string): number => {
	return 0;
	// return IslandSkuAssetData?.findBySku(sku)?.msrp ?? 0;
};
